import {createContext, PropsWithChildren, useCallback, useRef, useState} from 'react';
import { JdxpertService, JDxpertConfig } from 'types';
import { showNotification } from 'common/function';

type Settings = Pick<JDxpertConfig, 'prefix'> | null;

type JDXpertSettingsContextType = {
  settings: Settings,
  loadSettings: (force?: boolean) => void,
  isLoading: boolean,
};

export const JDXpertSettingsContext = createContext<JDXpertSettingsContextType>({
  settings: null,
  loadSettings: () => {},
  isLoading: false,
});

export const JDXpertSettingsProvider = ({ children }: PropsWithChildren) => {
  const [settings, setSettings] = useState<Settings>(null);
  const [isLoading, setIsLoading] = useState(false);
  const isLoaded = useRef(false);

  const loadSettings = useCallback(
    async (force?: boolean) => {
      if (force || !isLoaded.current) {
        isLoaded.current = true;
        setIsLoading(true);

        try {
          const { jdxpertConfig } = await JdxpertService.getJDxpertConfig();
          setSettings(jdxpertConfig as Settings);
        } catch (e: any) {
          showNotification(e.message, 'JDXpert settings load failed', 'error');
        }

        setIsLoading(false);
      }
    },
    [],
  );

  return (
    <JDXpertSettingsContext.Provider value={{ settings, loadSettings, isLoading }}>
      {children}
    </JDXpertSettingsContext.Provider>
  );
};
